export const TRADES = ["Janitorial", "HVAC", "Electrical", "Plumbing", "Security", "Landscaping", "Engineering", "General Contractor", "Pest Control", "Elevator & Escalator", "IT"];

// Used for facilities/{id}.timeZone — drives functions/index.js's
// checkMissedVisits (schedule endTime is wall-clock in this zone). A short
// curated US list, not the full IANA database — every current customer is
// US-based; revisit if that changes.
export const TIME_ZONES = [
  ["America/New_York", "Eastern"],
  ["America/Chicago", "Central"],
  ["America/Denver", "Mountain"],
  ["America/Phoenix", "Mountain, no DST (Arizona)"],
  ["America/Los_Angeles", "Pacific"],
  ["America/Anchorage", "Alaska"],
  ["Pacific/Honolulu", "Hawaii"],
];
